import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { contractVersicherungsangabenSectionConfig } from '@/features/Sparten/shared/kfz/contractVersicherungsangabenSectionConfig';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_ALLGEMEIN]: {
    label: 'Allgemein',
    component: () =>
      import('@/features/Sparten/kradv2/sections/input/InputAllgemein.vue'),
  },
  [SECTION.KFZ_INPUT_CAR]: {
    label: 'Fahrzeug',
    component: () =>
      import('@/features/Sparten/kradv2/sections/input/InputFahrzeug.vue'),
  },
  [SECTION.KFZ_INPUT_FIRST_CAR]: {
    label: 'Erstfahrzeug',
    component: () =>
      import('@/features/Sparten/kradv2/sections/input/InputErstfahrzeug.vue'),
  },
  [SECTION.KFZ_VN]: {
    label: 'Angaben zum Versicherungsnehmer',
    component: () =>
      import(
        '@/features/Sparten/kradv2/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.KFZ_INPUT_ABWEICHENDERHALTER]: {
    label: 'Angaben zum abweichenden Halter',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/kfz/input/InputAbweichenderHalter.vue'
      ),
  },
  [SECTION.KFZ_INPUT_FAHRERKREIS]: {
    label: 'Fahrerkreis',
    component: () =>
      import('@/features/Sparten/kradv2/sections/input/InputFahrerkreis.vue'),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/kradv2/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    disabledPaths: ['demvRabattiert'],
    component: () =>
      import(
        '@/features/Sparten/kradv2/sections/input/InputBeitragsreduzierung.vue'
      ),
  },
};

export const kradVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig: contractVersicherungsangabenSectionConfig,
};
